import './style.scss';
import React, { Component } from 'react';
import { MODAL_QUESTION_MULTY_FORM, showModal } from '../../../../../../modules/modals';
import { connect } from 'react-redux';
import { deleteQuestion, getCategoriesUp, updateQuestion, updateQuestionsOder } from '../../../../actions';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import { Switch, Modal as ModalAnt } from 'antd';
import { PhotoProvider, PhotoView } from 'react-photo-view';
import 'react-photo-view/dist/react-photo-view.css';
import Answers from './components/Answers/Answers';
import { toastr } from 'react-redux-toastr';
import {cloneDeep} from 'lodash'

export class Item extends Component {
  static contextTypes = {formatMessage: PropTypes.any};
  constructor(props) {
    super(props)
    this.state = {
      spinner: true,
      modal: false,
      shared: false,
    }
  }


  copy = () => {
    var copyText = document.getElementById("question_frame");
    const {formatMessage} = this.context
    /* Select the text field */
    copyText.select();
    copyText.setSelectionRange(0, 99999); /* For mobile devices */

    /* Copy the text inside the text field */
    document.execCommand("copy");
    toastr.success(formatMessage('titleFrameQuestionCopy'), formatMessage('msgFrameQUestionCopy'))
  }

  changeOrder = (tmp_index) => {
    const {items, indexEl, updateQuestionsOder} = this.props;
    console.log("🚀 ~ file: Item.jsx ~ line 40 ~ Item ~ tmp_index", tmp_index, indexEl)

    const ids = [];
    items.forEach((_i, i) => {
      if(i == tmp_index){
        ids.push({id: items[indexEl].id, order: i})
      } else if(i == indexEl){
        ids.push({id: items[tmp_index].id, order: i})
      } else {
        ids.push({id: _i.id, order: i})
      }
    });
    updateQuestionsOder({ids: JSON.stringify(ids)})
    // cloneDeep(items).splice(indexEl, 0, items[tmp_index]).splice(tmp_index, 0, items[indexEl]).forEach((_i,i) => {
    //   ids[_i.id] = i;
    // });
    console.log("🚀 ~ file: Item.jsx ~ line 49 ~ Item ~ ids", ids)
  }


  render() {
    const {formatMessage} = this.context;
    const {item, showModal, deleteQuestion, items, indexEl, getCategoriesUp, subject_selcted, categories} = this.props;
    console.log("🚀 ~ file: Item.jsx ~ line 23 ~ Item ~ render ~ item", item)
    const { modal, shared  } = this.state;

    let subject_id = (categories.find(_i => _i.id == item.category_id) || {subject_id: ''}).subject_id;

    if(subject_id){
      subject_id = parseInt(subject_id)
    }
  
    const typeTitle = {
      type1: 'equalText',
      type2: 'multySeleteAnswer',
      type3: 'sortAnswers',
      type4: 'sortAnswersCategories',
      type5: 'equalTextVariants',
      type6: 'imageLabel',
      type7: 'imageLabel',
    }


    return <div className='ItemQuestionMulty'>
      <Modal
        isOpen = {modal}
        style = {{
            overlay : {zIndex: 9999999},
        }}
        onRequestClose={() => {}}
        overlayClassName = "custom-modal"
        className = "custom-modal-content create-dialog-modal-content"
      >
        <div className="create-dialog-modal-content__header">
          <div className="create-dialog-modal-content__title">{formatMessage('msgTextCloseQuestionModalDelete')}</div>
        </div>
        <div className="create-dialog-modal-content__body">
          <div className="create-dialog-form form-quiz-create">
            <div className="col-xs-12 text-center word-wrap-break" style={{marginBottom: 10}}>{formatMessage('msgTextQuestionModalDelete')}</div>
            <div className="create-dialog-form__group flex">
              <button className="btn btn-primary" type="button" onClick={async () => {
                this.setState({modal: false})
                await deleteQuestion(item.id)
                if(subject_selcted && subject_selcted.id){
                  getCategoriesUp(subject_selcted.id)
                }
                document.body.classList.remove('ReactModal__Body--open');
              }}>{formatMessage('Yes')}</button>
              <button className="btn btn-warning" type="button" onClick={() => {
                this.setState({modal: false});
                document.body.classList.remove('ReactModal__Body--open');
              }}>{formatMessage('No')}</button>
            </div>
          </div>
          
        </div>
      </Modal>
      <Modal
        isOpen = {shared}
        style = {{
            overlay : {zIndex: 9999999},
        }}
        onRequestClose={() => {this.setState({shared: false})}}
        overlayClassName = "custom-modal"
        className = "custom-modal-content create-dialog-modal-content"
      >
        <div className="create-dialog-modal-content__header">
          <div className="create-dialog-modal-content__title">{formatMessage('msgTextQuestionModalShared')}</div>
          <div
            onClick={() => {
              this.setState({shared: false});
              document.body.classList.remove('ReactModal__Body--open');
            }}
            className="create-dialog-modal-content__close"
          ></div>
        </div>
        <div className="create-dialog-modal-content__body">
          <div className="create-dialog-form form-quiz-create">
            {/* <div className="col-xs-12 text-center word-wrap-break" style={{marginBottom: 10}}>{formatMessage('msgTextQuestionModal')}</div> */}
            <textarea rows={4} id="question_frame" style={{width: '100%', border: '1px solid #d9d9d9'}}>
              {`<iframe src="https://${window.location.hostname}/question_multy/view/${item.token}" width="100%" height="670" frameborder="0"></iframe>`}
            </textarea>
            <div className="create-dialog-form__group flex" style={{marginTop: 20}}>
              <button className="btn btn-primary" type="button" onClick={this.copy}>{formatMessage('copyQUestionFrame')}</button>
              <a className="btn btn-primary" target='_blank' href={'/question_multy/view/' + item.token} >{formatMessage('openQuestionPr')}</a>
            </div>
          </div>
          
        </div>
      </Modal>
      <div className='actions'>
        {/* <div className='icon block-icon'>
          <Switch size="small" checked={item.is_show} onChange={() => {
            updateQuestion({...item, is_show: !item.is_show})
          }} />
        </div> */}
        <div className='icon' onClick={() => {
          showModal({
            modalType : MODAL_QUESTION_MULTY_FORM,
            modalProps : {
              initialValues: {...item, subject_id},
            }
          });
        }}>
          <img src="/build/images/method-draw-image.svg" width="48" height="48"/>
        </div>
        <div className='icon' onClick={() => {this.setState({modal: true})}}>
          <img src="/build/images/GarbageButton.svg?dd496e1175bddf2473114d4037e004a8" width="48" height="48"/>
        </div>
        <div className='icon icon_block' onClick={() => {
          this.setState({shared: true})
        }}>
          <i className="fa fa-eye"></i>
        </div>
        {indexEl > 0 && <div className='icon icon_block' title={formatMessage('questionUP')} onClick={() => {
          if(indexEl >= 0){
            this.changeOrder(indexEl -1)
          }
        }}>
          <i className="fa fa-chevron-up"></i>
        </div>}
        {indexEl < items.length -1 && <div className='icon icon_block' title={formatMessage('questionDOWN')} onClick={() => {
          if(indexEl < items.length -1){
            this.changeOrder(indexEl +1)
          }
        }}>
          <i className="fa fa-chevron-down"></i>
        </div>}
      </div>
      <div className='title'><div>{formatMessage('Question')}</div><div>{formatMessage(typeTitle[item.question_type] || '')}</div></div>
      <div className='question'>
        <div className='text'>
          <div style={{width: '100%'}} dangerouslySetInnerHTML={{__html: item.question}}/>
        </div>
      </div>
      {item.question_type == 'type5' && <div style={{width: '100%', margin: '0 10px'}}>
        {item.answers.value}
      </div>}
      
      <div className='title'>{formatMessage('Answers')}</div>
      <Answers answers={item.answers} questionType={item.question_type}  />
    </div>;
  }
}

const mapStateToProps = (state, ownProps) => ({
  subject_selcted: state.question.subject_selcted,
  subjects: state.question.subjects,
  categories: state.question.categories,
})

const mapDispatchToProps = {
  updateQuestion,
  showModal,
  deleteQuestion,
  getCategoriesUp,
  updateQuestionsOder,
}

export default connect(mapStateToProps, mapDispatchToProps)(Item);




// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Question/components/Questions/components/Item/Item.jsx